// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"283":"22288a6a","996":"e095bdf0"}[chunkId] + ".chunk.js";
};